<template>
  <Modal
    id="program-objective"
    :modal="programObjectiveRef"
    :steps="[{ component: ProgramObjectiveModalContent, id: 'program-objective' }]"
  />
</template>

<script setup lang="ts">
import Modal from '@/features/ui/components/modal/modal.vue'
import { selectGetProgramObjectiveModal } from '@/features/ui/store/modal/modal.selectors'
import modalsStore from '@/features/ui/store/modal/modal.store'
import ProgramObjectiveModalContent from './program-objective-modal-content/program-objective-modal-content.vue'

const programObjectiveRef = selectGetProgramObjectiveModal(modalsStore)
</script>